import { PartialType, ApiPropertyOptional } from '@nestjs/swagger'
import { IsUUID, IsOptional } from 'class-validator'
import { CreateProgramConceptCompetencyDto } from './create-program-concept-competency.dto'

export class UpdateProgramConceptCompetencyDto extends PartialType(
  CreateProgramConceptCompetencyDto
) {
  @ApiPropertyOptional({ description: 'Program concept UUID' })
  @IsUUID()
  @IsOptional()
  override programConceptId?: string

  @ApiPropertyOptional({ description: 'Program competency UUID' })
  @IsUUID()
  @IsOptional()
  override programCompetencyId?: string
}
